// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__1L0qg","preview":"Item_preview__3vFLk","number":"Item_number__3qcp_","title":"Item_title__1XDIa","time":"Item_time__YRQj5"};